module.exports = __webpack_public_path__ + "assets/images/631a9d423aabe3b3dc2275b8b18fa6ca.svg";